import { render } from "./ListeHospitalisation.vue?vue&type=template&id=e0357ada&scoped=true"
import script from "./ListeHospitalisation.vue?vue&type=script&lang=js"
export * from "./ListeHospitalisation.vue?vue&type=script&lang=js"

import "./ListeHospitalisation.vue?vue&type=style&index=0&id=e0357ada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0357ada"]])

export default __exports__